import { Box, Divider, List } from "@chakra-ui/react"
import React, { useEffect, useRef } from "react"
import { useInViewport } from "react-in-viewport"
import { ExtendedAlertTargetGroupFragment } from "../../graphql"
import { AlertTargetGroupListItem } from "./AlertTargetGroupListItem"

export type AlertTargetGroupsListProps = {
	alertTargetGroups: ExtendedAlertTargetGroupFragment[]
	loadMore: () => void
}

export const AlertTargetGroupsList: React.FC<AlertTargetGroupsListProps> = ({ alertTargetGroups, loadMore }) => {
	const ref = useRef()

	const { inViewport } = useInViewport(ref as any, { threshold: 0.25 })

	useEffect(() => {
		if (inViewport) {
			loadMore()
		}
	}, [inViewport, loadMore])

	return (
		<List spacing={2}>
			{alertTargetGroups.map((alertTargetGroup) => (
				<>
					<AlertTargetGroupListItem key={alertTargetGroup._id} alertTargetGroup={alertTargetGroup} />
					<Divider />
				</>
			))}
			<Box w="full" h="2" ref={ref as any} />
		</List>
	)
}
